import { render, staticRenderFns } from "./InvestorOnboardingRegisterPage.vue?vue&type=template&id=4730380e&scoped=true&"
import script from "./InvestorOnboardingRegisterPage.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingRegisterPage.vue?vue&type=script&lang=js&"
import style0 from "./InvestorOnboardingRegisterPage.vue?vue&type=style&index=0&id=4730380e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4730380e",
  null
  
)

export default component.exports